import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  'profileInfoLoaded': false,
  'profile': {}
}

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    loadProfile: (state, action) => {
      state.profileInfoLoaded = true;
      state.profile = action.payload.profileInfo;
    },
    profileUploaded: (state) => {
      state.profileInfoLoaded = false;
    },
    resetProfile: (state) => {
      state.profile = {}
      state.profileInfoLoaded = false;
    }
  },
})

export const { loadProfile, profileUploaded, resetProfile } = profileSlice.actions
export default profileSlice.reducer